import React, { memo, useEffect, useRef, useState, forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import ResizeObserver from 'react-resize-observer';

import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { Scrollbars } from "react-custom-scrollbars";

import { HighlightSpan } from './PriceBoardTotalMode';
//
import { changeSortConfig, addFavSymbol, removeFavSymbol, changeSelectShowInfo, showPopupInfo, removeFindSymbol, changeSortConfigMenu, addSummarySymbol, removeSummarySymbol } from '../redux/actions/sharedActions';

import { formatQtty, formatNumberToM, formatNumber, formatPctChangePrice } from '../helpers/utils';
import { Input } from 'antd';
import { useApiCategoryStock } from '../helpers/apiCategoryStock';
import { constTabName } from '../helpers/constData';
import { SortableFixedSizeList } from '../libarySortTableDrapDrop';

// ===== TABLE DETAIL =====
export default memo(function PriceBoardDetailMode(props) {
    // Props var
    const { symbolInfos, tabName } = props;

    //
    return (
        <div className={'price-board'}>
            <TableBody symbolInfos={symbolInfos} tabName={tabName} />
        </div>
    )
})

//
const TableBody = forwardRef((props, ref) => {
    //
    const { symbolInfos, onScroll, tabName } = props;
    //
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const findSymbol = useSelector(state => state.gShared.findSymbol);
    const priceBoardSortConfig = useSelector(state => state.gShared.priceBoardSortConfig);
    const crrSortColumn = priceBoardSortConfig ? priceBoardSortConfig.column ?? '' : '';
    const crrSortType = priceBoardSortConfig ? priceBoardSortConfig.type ?? '' : '';

    const priceBoardColumnConfig_UpdateTime = useSelector(state => state.gShared.priceBoardColumnConfig?.updateTime);
    const priceBoardColumnConfig = useSelector(state => state.gShared.priceBoardColumnConfig?.DETAIL ?? {});


    const configShowHideColumn = useSelector(state => state.gShared.configShowHideColumn);
    const configSortColumnMenu = useSelector((state) => state.gShared.configSortColumnMenu);

    //
    const refHeaderRow = useRef(null);
    const [headerRowHeight, setHeaderRowHeight] = useState(0);

    const refBidPrice3 = useRef(null);
    const refBidQtty1 = useRef(null);

    const refOfferPrice1 = useRef(null);
    const refOfferQtty3 = useRef(null);

    const [showTotalValue, setShowTotalValue] = useState(false);
    const [showPercent, setShowPercent] = useState(false);

    //
    const refBid = useRef(null);
    const refOffer = useRef(null);
    const refTable = useRef(null);
    const refScroll = useRef(null);

    const configColumnNameTable = {
        symbolColAsc: 'code',
        symbolColDesc: 'code',
        totalQttyColAsc: 'totalTradedQttyNM',
        totalQttyColDesc: 'totalTradedQttyNM',
        foreignBuyColAsc: 'buyForeignQtty',
        foreignBuyColDesc: 'buyForeignQtty',
        foreignSellColAsc: 'sellForeignQtty',
        foreignSellColDesc: 'sellForeignQtty',
    };

    useEffect(() => {
        changeSortConfigMenu(dispatch, configColumnNameTable, configSortColumnMenu);
    }, [configSortColumnMenu])

    useImperativeHandle(ref, () => ({
        scrollBody: refScroll.current,
        scrollToItem: (itemIdx) => {
            if (refTable.current) {
                refTable.current.scrollToItem(itemIdx);
            }
        },
    }));

    //
    const measureRefBid = useCallback(node => {
        if (node !== null) {
            refBid.current = node;
        }
    }, [])

    //
    const measureRefOffer = useCallback(node => {
        if (node !== null) {
            refOffer.current = node;
        }
    }, [])

    const _handleChangeShowTotalValue = () => {
        if (showTotalValue) {
            setShowTotalValue(false);
        }
        else {
            setShowTotalValue(true);
        }
    }
    const _handleChangeShowPercent = () => {
        if (showPercent) {
            setShowPercent(false);
        }
        else {
            setShowPercent(true);
        }
    }

    const _handleClickSort = (colName, dataType) => {
        // localStorage.removeItem(window.location.pathname);
        changeSortConfig(dispatch, crrSortColumn, crrSortType, colName, dataType);
    }

    const _handleScroll = useCallback(({ target }) => {
        const { scrollTop, scrollLeft } = target;
        if (refTable.current) {
            refTable.current.scrollTo(scrollTop);
        }
        //
        if (onScroll) {
            try {
                onScroll({ target });
            } catch (error) {
            }
        }
    }, [refTable.current])

    const _handleTableScroll = useCallback(({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
        if (refScroll.current) {
            refScroll.current.scrollTop(scrollOffset);
        }
        if (findSymbol && findSymbol.code && findSymbol.code !== "") {
            removeFindSymbol(dispatch, "");
        }
    }, [refScroll.current])

    const _scrollToSymbol = () => {
        if (refTable.current) {
            if (findSymbol && findSymbol.code && findSymbol.code !== "" && symbolInfos && symbolInfos.length > 0) {
                const _idx = symbolInfos.findIndex(e => e.code === findSymbol.code);
                if (_idx >= 0) {
                    if (refTable.current) {
                        refTable.current.scrollToItem(_idx, 'start');
                    }
                }
            }
        }
        else {
            setTimeout(() => {
                _scrollToSymbol();
            }, 100);
        }
    }

    const _calcDivBidPosition = () => {
        if (refHeaderRow.current && refBidPrice3.current && refBidQtty1.current && refBid.current) {
            const _headerRowRect = refHeaderRow.current.getBoundingClientRect();
            const _bidPrice3Rect = refBidPrice3.current.getBoundingClientRect();
            const _bidQtty1Rect = refBidQtty1.current.getBoundingClientRect();
            const _left = _bidPrice3Rect.x - _headerRowRect.x;
            const _width = (_bidQtty1Rect.x - _bidPrice3Rect.x) + _bidQtty1Rect.width;
            refBid.current.style.left = _left + "px";
            refBid.current.style.width = _width + "px";
        }
        else {
            setTimeout(() => { _calcDivBidPosition(); }, 250);
        }
    }

    const _calcDivOfferPosition = () => {
        if (refHeaderRow.current && refOfferPrice1.current && refOfferQtty3.current && refOffer.current) {
            const _headerRowRect = refHeaderRow.current.getBoundingClientRect();
            const _offerPrice1Rect = refOfferPrice1.current.getBoundingClientRect();
            const _offerQtty3Rect = refOfferQtty3.current.getBoundingClientRect();
            const _left = _offerPrice1Rect.x - _headerRowRect.x;
            const _width = (_offerQtty3Rect.x - _offerPrice1Rect.x) + _offerQtty3Rect.width;
            refOffer.current.style.left = _left + "px";
            refOffer.current.style.width = _width + "px";
        }
        else {
            setTimeout(() => { _calcDivOfferPosition(); }, 250);
        }
    }

    const _calcDivPosition = () => {
        _calcDivBidPosition();
        _calcDivOfferPosition();
    }

    //
    useEffect(() => {
        _scrollToSymbol();
    }, [findSymbol.counter, symbolInfos.length])

    useEffect(() => {
        _calcDivPosition();
    }, [priceBoardColumnConfig_UpdateTime, configShowHideColumn])
    const refForBidPrice = !configShowHideColumn.includes("colBuyVol4") ? refBidPrice3 : null;
    const refForBidQtty = configShowHideColumn.includes("colBuyVol4") ? refBidPrice3 : null;
    const refForsSellBidPrice = !configShowHideColumn.includes("colSellVol4") ? refOfferQtty3 : null;
    const refForSellBidQtty = configShowHideColumn.includes("colSellVol4") ? refOfferQtty3 : null;
    //
    return (
        <AutoSizer>
            {({ height, width }) => {
                return (
                    <Scrollbars
                        ref={refScroll}
                        autoHide={true}
                        autoHeight={true}
                        autoHeightMax={height}
                        onScroll={_handleScroll}
                        style={{ width: width, position: 'relative' }}
                        renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal" />}
                        renderTrackVertical={props => <div {...props} className="scroll-track-vertical" />}
                        renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal" />}
                        renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical" />}
                        renderView={props => <div {...props} className="scroll-view" />}
                        className={"scroll-container"}
                    >
                        <div style={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                            <div ref={refHeaderRow} className="prc-row-head prc-row-head-spec">
                                <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />

                                {/* <div className="prc-col mw-40"></div> */}
                                {priceBoardColumnConfig.showCode && (
                                    <div className={clsx("prc-col4 text-center th-sort bdl-white", (crrSortColumn === 'code' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('code')}>{t('maCK')}</div>
                                )}
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'ceilPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('ceilPrice', 'number')}>{t('tran')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'floorPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('floorPrice', 'number')}>{t('san')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'refPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('refPrice', 'number')}>{t('tc')}</div>
                                <div ref={refForBidQtty} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort bdl-white",  (!configShowHideColumn.includes("colBuyVol4") ? 'hidden' : ''), (crrSortColumn === 'bidQtty4' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQtty4', 'number')}>
                                    {t('kl4')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>  
                                <div ref={refForBidPrice}  className={clsx("prc-col-rs prc-col2 text-center th-sort ", (!configShowHideColumn.includes("colBuyVol4") ? 'bdl-white' : ''), (crrSortColumn === 'bidPrice3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPrice3', 'number')}>
                                    {t('gia3')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>                                
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort ", (crrSortColumn === 'bidQtty3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQtty3', 'number')}>{t('kl3')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'bidPrice2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPrice2', 'number')}>{t('gia2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'bidQtty2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQtty2', 'number')}>{t('kl2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'bidPrice1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPrice1', 'number')}>{t('gia1')}</div>
                                <div ref={refBidQtty1} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'bidQtty1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQtty1', 'number')}>
                                    {t('kl1')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>

                                <div className={clsx("prc-col4 text-center mw-75 mxw-75 bdl-white", (!configShowHideColumn.includes("colSubSymbol") ? 'hidden' : ''))}></div>

                                <div ref={measureRefBid} className={"prc-col-cs prc-col-bid bdl-white"}>{t('muaBid')}</div>

                                {priceBoardColumnConfig.showCodeMatch && (
                                    <div className={clsx("prc-col4 text-center mw-75 mxw-75 th-sort", (crrSortColumn === 'code' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('code')}>{t('maCK')}</div>
                                )}
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'matchPrice' ? 'th-sort-' + crrSortType : '', (!configShowHideColumn.includes("colSubSymbol") ? 'bdl-white' : '')))} onClick={() => _handleClickSort('matchPrice', 'number')}>{t('giaKhop')}</div>
                                <div className={clsx("prc-col2 mw-55 text-center")} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                        <div className='d-flex align-items-center h-100 pdr-3 pr-icon-btn' onClick={_handleChangeShowPercent}>
                                            <i className="fas fa-caret-left"></i>
                                        </div>
                                        {showPercent ? (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'pctChangePrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('pctChangePrice', 'number')}>%</div>
                                        ) : (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'changePrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('changePrice', 'number')}>+/-</div>
                                        )}
                                        <div className='d-flex align-items-center h-100 pdl-3 pr-icon-btn' onClick={_handleChangeShowPercent}>
                                            <i className="fas fa-caret-right"></i>
                                        </div>
                                    </div>
                                {/* <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'changePrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('changePrice', 'number')}>+/-</div>
                                <div className={clsx("prc-col2 text-center mw-55 th-sort", (crrSortColumn === 'pctChangePrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('pctChangePrice', 'number')}>%</div> */}
                                <div className={clsx("prc-col2 text-center mw-65 th-sort", (crrSortColumn === 'matchQtty' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('matchQtty', 'number')}>{t('klKhop')}</div>
                                {priceBoardColumnConfig.showTotalTradedQtty && (
                                    <div className={clsx("prc-col4 mw-85", (!configShowHideColumn.includes("colTotalBuy") ? 'hidden' : ''))} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                        <div className='d-flex align-items-center h-100 pdr-3 pr-icon-btn' onClick={_handleChangeShowTotalValue}>
                                            <i className="fas fa-caret-left"></i>
                                        </div>
                                        {showTotalValue ? (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'totalTradedValueNM' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('totalTradedValueNM', 'number')}>{t('tongGTKhop')}</div>
                                        ) : (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'totalTradedQttyNM' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('totalTradedQttyNM', 'number')}>{t('tongKLKhop')}</div>
                                        )}
                                        <div className='d-flex align-items-center h-100 pdl-3 pr-icon-btn' onClick={_handleChangeShowTotalValue}>
                                            <i className="fas fa-caret-right"></i>
                                        </div>
                                    </div>
                                )}
                                <div ref={refOfferPrice1} className={clsx("prc-col-rs prc-col2 text-center th-sort bdl-white", (crrSortColumn === 'offerPrice1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPrice1', 'number')}>
                                    {t('gia1')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQtty1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQtty1', 'number')}>{t('kl1')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'offerPrice2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPrice2', 'number')}>{t('gia2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQtty2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQtty2', 'number')}>{t('kl2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'offerPrice3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPrice3', 'number')}>{t('gia3')}</div>
                                <div ref={refForsSellBidPrice} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQtty3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQtty3', 'number')}>
                                    {t('kl3')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div ref={refForSellBidQtty} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort",(!configShowHideColumn.includes("colSellVol4") ? 'hidden' : ''), (crrSortColumn === 'offerQtty4' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQtty4', 'number')}>
                                    {t('kl4')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div ref={measureRefOffer} className={"prc-col-cs prc-col-ask bdl-white"}>{t('banAsk')}</div>

                                <div className={clsx("prc-col2 text-center th-sort bdl-white", (crrSortColumn === 'avgPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('avgPrice', 'number')}>{t('giaTB')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'highestPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('highestPrice', 'number')}>{t('caoNhat')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'lowestPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('lowestPrice', 'number')}>{t('thapNhat')}</div>

                                {priceBoardColumnConfig.showBuyForeignQtty && (
                                    <div className={clsx("prc-col2 text-center mw-70 th-sort", (crrSortColumn === 'buyForeignQtty' ? 'th-sort-' + crrSortType : ''), (!configShowHideColumn.includes("colNNbuy") ? 'hidden' : ''))} onClick={() => _handleClickSort('buyForeignQtty', 'number')}>{t('nnMua')}</div>
                                )}
                                {priceBoardColumnConfig.showSellForeignQtty && (
                                    <div className={clsx("prc-col2 text-center mw-70 th-sort", (crrSortColumn === 'sellForeignQtty' ? 'th-sort-' + crrSortType : ''), (!configShowHideColumn.includes("colNNsell") ? 'hidden' : ''))} onClick={() => _handleClickSort('sellForeignQtty', 'number')}>{t('nnBan')}</div>
                                )}
                                {priceBoardColumnConfig.showRemainForeignQtty && (
                                    <div className={clsx("prc-col4 text-center mw-90 th-sort", (crrSortColumn === 'remainForeignQtty' ? 'th-sort-' + crrSortType : ''), (!configShowHideColumn.includes("colRoom") ? 'hidden' : ''))} onClick={() => _handleClickSort('remainForeignQtty', 'number')}>Room</div>
                                )}
                            </div>
                            <ResizeObserver onResize={(rect) => { setHeaderRowHeight(rect.height); }} />
                        </div>
                        <ScrollContent symbolInfos={symbolInfos} height={height - headerRowHeight} onScroll={_handleTableScroll} showTotalValue={showTotalValue} ref={refTable} tabName={tabName} showPercent={showPercent}/>
                    </Scrollbars>
                )
            }}
        </AutoSizer>
    )
})

//
const ScrollContent = memo(forwardRef(function (props, ref) {
    const { symbolInfos, height, onScroll, showTotalValue, tabName,showPercent } = props;
    //
    return (
        <FixedSizeList
            ref={ref}
            height={height}
            width={'100%'}
            itemCount={symbolInfos.length}
            itemSize={28}
            style={{ overflow: false }}
            onScroll={onScroll}
            overscanCount={30}
        >
            {({ index, style }) => {
                const _symbolInfo = symbolInfos[index];
                return (
                    <RowFlex className={"prc-row " + (index % 2 === 0 ? "odd" : "even")} style={{ ...style }}
                        counter={_symbolInfo.counter} code={_symbolInfo.code} showTotalValue={showTotalValue} tabName={tabName} showPercent={showPercent}/>
                )
            }}
        </FixedSizeList>
    )
}))

// const ScrollContent = memo(forwardRef(function (props, ref) {
//     const { symbolInfos, height, onScroll, showTotalValue, tabName, showPercent } = props;

//     const [sortChanged, setSortChanged] = useState(false);
//     const sortedSymbolInfos = useMemo(() => {
//         var savedSortedCodes = (localStorage.getItem(window.location.pathname) ?? '').split(',');
//         var tempInfos = symbolInfos.map(e => {
//             var sortIndex = savedSortedCodes.indexOf(e.code);
//             return { ...e, ___sortIndex: sortIndex < 0 ? 999999 : sortIndex };
//         });
 
//         tempInfos = tempInfos.sort((a, b) => a.___sortIndex - b.___sortIndex);
 
//         return tempInfos;
//     }, [sortChanged, symbolInfos]);
 
//     const handleSort = ({ originalIndex, newIndex }) => {
//         const symbolCodes = [...sortedSymbolInfos.map(x => x.code)];
//         const [movedItem] = symbolCodes.splice(originalIndex, 1);
//         symbolCodes.splice(newIndex, 0, movedItem);
 
//         localStorage.setItem(window.location.pathname, symbolCodes);
 
//         setSortChanged(o => !o);
//     };

//     //
//     return (
//         <SortableFixedSizeList
//             ref={ref}
//             height={height}
//             width={'100%'}
//             itemCount={sortedSymbolInfos.length}
//             itemSize={28}
//             style={{ overflow: false }}
//             onScroll={onScroll}
//             overscanCount={30}
//             onSortOrderChanged={handleSort}
//         >
//             {React.forwardRef(({ index, style, onSortMouseDown }, ref) => {
 
//                 const _symbolInfo = sortedSymbolInfos[index];
//                 return (
//                     <RowFlex className={"prc-row " + (index % 2 === 0 ? "odd" : "even")} ref={ref} style={style} onMouseDown={onSortMouseDown}
//                         counter={_symbolInfo.counter} code={_symbolInfo.code} showTotalValue={showTotalValue} tabName={tabName} showPercent={showPercent} />
//                 )
//             })}
//         </SortableFixedSizeList>
//     )
// }))

//
const RowFlex = memo(forwardRef(function (props, ref) {
    const { code, showTotalValue, tabName,showPercent } = props;

    const apiCategoryStock = useApiCategoryStock();

    //
    const dispatch = useDispatch();
    const prevSymbolCode = useRef(""); // .current

    const tabIsFocus = useSelector(state => state.gShared.tabIsFocus);
    const counter = useSelector(state => state.gSymbol.symbolInfos.find((e) => e.code === code).counter);
    const symbolInfo = useSelector(state => state.gSymbol.symbolInfos.find((e) => e.code === code));
    const isFav = useSelector(state => state.gShared.priceBoardFavSymbols.indexOf(symbolInfo.code) >= 0);

    const priceBoardColumnConfig_UpdateTime = useSelector(state => state.gShared.priceBoardColumnConfig?.updateTime);
    const priceBoardColumnConfig = useSelector(state => state.gShared.priceBoardColumnConfig?.DETAIL ?? {});
    const priceBoardIsOddlot = useSelector(state => state.gShared.priceBoardIsOddlot);

    const _fireEvent = prevSymbolCode.current === symbolInfo.code && tabIsFocus;
    const priceBoardFavSymbols = useSelector((state) => state.gShared.priceBoardFavSymbols);
    const priceBoardSummarySymbols = useSelector((state) => state.gShared.priceBoardSummarySymbols);

    const lastSymbol = useSelector((state) => state.gShared.lastSymbol);

    const categoryStocks = useSelector((state) => state.gShared.categoryStocks) ?? [];
    const currentCategory = useSelector((state) => state.gShared.currentCategory) ?? [];
    const configShowHideColumn = useSelector(state => state.gShared.configShowHideColumn);

    //
    const _addFavSymbol = useCallback((code) => {
        addFavSymbol(dispatch, code);
    }, [])

    const _removeFavSymbol = useCallback((code) => {
        removeFavSymbol(dispatch, code);

        handleRemoveStockIntoCategory(code)
    }, [])

    const getCategoryStock = async () => {
        const { data: loaded } = await apiCategoryStock.CategoryStock();
        dispatch({
            type: "GET_CATEGORY_STOCK",
            payload: loaded.arrCata,
        });
    };

    const handleRemoveStockIntoCategory = async (code) => {
        await apiCategoryStock.EditGroupStock({ lstid: currentCategory, code: code, type: "D" })
            .then((res) => {
                if (res.status === 200) {
                    // setSearchValue("");
                }
            })
            .catch((err) => {
                console.log("err => ", err);
            })
            .finally(() => {
                getCategoryStock();
            });
    };

    const _handleRowClick = useCallback((event, code) => {
        if (code) {
            if (code + "_code" === event.target.id || code + "_codeMatch" === event.target.id) {
                showPopupInfo(dispatch, "ST", code);
            }
            else if (code + "_star" === event.target.id) {
                //
            }
            else {
                changeSelectShowInfo(dispatch, "ST", code);
            }
        }
    }, [])
    //
    useEffect(() => {
        prevSymbolCode.current = symbolInfo.code;
    }, [symbolInfo.code]);

    const changeFavSymbol = (checked, code) => {
        if (tabName && tabName === constTabName.TongHop) {
            if (checked) {
                addSummarySymbol(dispatch, code);
            } else {
                removeSummarySymbol(dispatch, code);
            }
        }
        else {
            if (checked) {
                _addFavSymbol(code);
            } else {
                _removeFavSymbol(code)
            }
        }
    }

    return (
        <div ref={ref} onMouseDown={props.onMouseDown} onClick={(event) => {
        _handleRowClick(event, symbolInfo.code)}} className={`${props.className} ${lastSymbol === symbolInfo.code && tabName !== "FAV" && tabName !== constTabName.TongHop ? "lastSymbol" : ""}`} style={{ ...props.style }}>
            {/* <div className="prc-col text-center mw-40">
                {
                    isFav ? (
                        <span onClick={() => _removeFavSymbol(symbolInfo.code)} style={{cursor: 'pointer', lineHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}><img id={symbolInfo.code + "_star"} className="imgstar" src="/static/img/icon/icon-star-yellow.svg" alt="img" />&nbsp;</span>
                    ) : (
                        <span onClick={() => _addFavSymbol(symbolInfo.code)} style={{cursor: 'pointer', lineHeight: 0,display:'flex',alignItems: 'center',justifyContent:'center',height: '100%' }}><img id={symbolInfo.code + "_star"} className="imgstar" src="/static/img/icon/icon-star.svg" alt="img" />&nbsp;</span>
                    )
                }
            </div> */}
            {priceBoardColumnConfig.showCode && (
                <div className="prc-col4 text-center has-symbol d-flex jtf-start pl-1" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                    <input type="checkbox" onChange={(e) => changeFavSymbol(e.target.checked, symbolInfo.code)} checked={tabName === constTabName.TongHop ? priceBoardSummarySymbols.includes(symbolInfo.code) : (priceBoardFavSymbols.includes(symbolInfo.code) || categoryStocks.filter(e => e.listid === currentCategory)[0]?.code?.split(',').includes(symbolInfo.code))} />
                    <span style={{ cursor: 'pointer', marginLeft: '6px' }} id={symbolInfo.code + "_code"} className={priceBoardIsOddlot ? symbolInfo.matchPriceOdd_color : symbolInfo.matchPrice_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                </div>
            )}
            <div className="prc-col2 text-right bg-smoke clr-ceil"><HighlightSpan id={symbolInfo.code + "_ceilPrice"} value={symbolInfo.ceilPrice} fireEvent={_fireEvent} /></div>
            <div className="prc-col2 text-right bg-smoke clr-floor"><HighlightSpan id={symbolInfo.code + "_floorPrice"} value={symbolInfo.floorPrice} fireEvent={_fireEvent} /></div>
            <div className="prc-col2 text-right bg-smoke clr-ref"><HighlightSpan id={symbolInfo.code + "_refPrice"} value={symbolInfo.refPrice} fireEvent={_fireEvent} /></div>

            {priceBoardIsOddlot ? (
                <>
                    <div className={clsx("prc-col2 text-right", symbolInfo.bidPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd3"} value={symbolInfo.bidPriceOdd3} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd3"} value={formatNumber(symbolInfo.bidQttyOdd3)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.bidPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd2"} value={symbolInfo.bidPriceOdd2} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd2"} value={formatNumber(symbolInfo.bidQttyOdd2)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.bidPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd1"} value={symbolInfo.bidPriceOdd1} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd1"} value={formatNumber(symbolInfo.bidQttyOdd1)} fireEvent={_fireEvent} /></div>

                    {priceBoardColumnConfig.showCodeMatch && (
                        <div className={clsx("prc-col4 text-center mw-75 mxw-75 bdl-white", (!configShowHideColumn.includes("colSubSymbol") ? 'hidden' : ''))} title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                            <span style={{ cursor: 'pointer' }} id={symbolInfo.code + "_codeMatch"} className={symbolInfo.matchPriceOdd_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                        </div>
                    )}
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPriceOdd_color, (!configShowHideColumn.includes("colSubSymbol") ? 'bdl-white' : ''))}><HighlightSpan id={symbolInfo.code + "_matchPriceOdd"} value={symbolInfo.matchPriceOdd} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_changePriceOdd"} value={symbolInfo.changePriceOdd} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-55 bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_pctChangePriceOdd"} value={symbolInfo.pctChangePriceOdd + (symbolInfo.pctChangePriceOdd && symbolInfo.pctChangePriceOdd !== '' ? '%' : '')} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65 bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_matchQttyOdd"} value={formatNumber(symbolInfo.matchQttyOdd)} fireEvent={_fireEvent} /></div>

                    {priceBoardColumnConfig.showTotalTradedQtty && (
                        <>
                            {showTotalValue ? (
                                <div className={clsx("prc-col4 mw-85 text-right bg-smoke")}><HighlightSpan id={symbolInfo.code + "_totalTradedValueOdd"} value={formatNumberToM(symbolInfo.totalTradedValueOdd)} fireEvent={_fireEvent} /></div>
                            ) : (
                                <div className={clsx("prc-col4 mw-85 text-right bg-smoke")}><HighlightSpan id={symbolInfo.code + "_totalTradedQttyOdd"} value={formatNumber(symbolInfo.totalTradedQttyOdd)} fireEvent={_fireEvent} /></div>
                            )}
                        </>
                    )}

                    <div className={clsx("prc-col2 text-right", symbolInfo.offerPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd1"} value={symbolInfo.offerPriceOdd1} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd1"} value={formatNumber(symbolInfo.offerQttyOdd1)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.offerPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd2"} value={symbolInfo.offerPriceOdd2} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd2"} value={formatNumber(symbolInfo.offerQttyOdd2)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.offerPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd3"} value={symbolInfo.offerPriceOdd3} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd3"} value={formatNumber(symbolInfo.offerQttyOdd3)} fireEvent={_fireEvent} /></div>

                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.highestPrice_color)}></div>
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.avgPrice_color)}></div>
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.lowestPrice_color)}></div>

                    {priceBoardColumnConfig.showBuyForeignQtty && (
                        <div className={clsx("prc-col2 text-right mw-70")}></div>
                    )}
                    {priceBoardColumnConfig.showSellForeignQtty && (
                        <div className={clsx("prc-col2 text-right mw-70")}></div>
                    )}
                    {priceBoardColumnConfig.showRemainForeignQtty && (
                        <div className={clsx("prc-col4 text-right mw-90")}></div>
                    )}
                </>
            ) : (
                <>
                    <div className={clsx("prc-col2 text-right bdl-white mw-65" , (!configShowHideColumn.includes("colBuyVol4") ? 'hidden' : ''), symbolInfo.bidPrice4_color)}><HighlightSpan id={symbolInfo.code + "_bidQtty4"} value={formatQtty(symbolInfo.bidQtty4)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right ",(!configShowHideColumn.includes("colBuyVol4") ? 'bdl-white' : ''), symbolInfo.bidPrice3_color)}><HighlightSpan id={symbolInfo.code + "_bidPrice3"} value={symbolInfo.bidPrice3} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPrice3_color)}><HighlightSpan id={symbolInfo.code + "_bidQtty3"} value={formatQtty(symbolInfo.bidQtty3)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.bidPrice2_color)}><HighlightSpan id={symbolInfo.code + "_bidPrice2"} value={symbolInfo.bidPrice2} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPrice2_color)}><HighlightSpan id={symbolInfo.code + "_bidQtty2"} value={formatQtty(symbolInfo.bidQtty2)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.bidPrice1_color)}><HighlightSpan id={symbolInfo.code + "_bidPrice1"} value={symbolInfo.bidPrice1} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPrice1_color)}><HighlightSpan id={symbolInfo.code + "_bidQtty1"} value={formatQtty(symbolInfo.bidQtty1)} fireEvent={_fireEvent} /></div>

                    <div className={clsx("prc-col4 text-left mw-75 mxw-75 has-symbol bdl-white", (!configShowHideColumn.includes("colSubSymbol") ? 'hidden' : ''))} title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                        <span style={{ cursor: 'pointer', marginLeft: '6px' }} id={symbolInfo.code + "_code"} className={priceBoardIsOddlot ? symbolInfo.matchPriceOdd_color : symbolInfo.matchPrice_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                    </div>

                    {priceBoardColumnConfig.showCodeMatch && (
                        <div className="prc-col4 text-center mw-75 mxw-75 bg-smoke" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                            <span style={{ cursor: 'pointer' }} id={symbolInfo.code + "_codeMatch"} className={symbolInfo.matchPrice_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                        </div>
                    )}
                    <div className={clsx("prc-col2 text-right bg-smoke ", symbolInfo.matchPrice_color, (!configShowHideColumn.includes("colSubSymbol") ? 'bdl-white' : ''))}><HighlightSpan id={symbolInfo.code + "_matchPrice"} value={symbolInfo.matchPrice} fireEvent={_fireEvent} /></div>
                        <>
                            {showPercent ? (
                                <div className={clsx("prc-col2 text-right mw-55 bg-smoke", symbolInfo.matchPrice_color)}><HighlightSpan id={symbolInfo.code + "_pctChangePrice"} value={formatPctChangePrice(symbolInfo.pctChangePrice) + (symbolInfo.pctChangePrice && symbolInfo.pctChangePrice !== '' ? '' : '')} fireEvent={_fireEvent} /></div>
                            ) : (
                                <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPrice_color)}><HighlightSpan id={symbolInfo.code + "_changePrice"} value={symbolInfo.changePrice} fireEvent={_fireEvent} /></div>
                            )}
                        </>
                    {/* <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPrice_color)}><HighlightSpan id={symbolInfo.code + "_changePrice"} value={symbolInfo.changePrice} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-55 bg-smoke", symbolInfo.matchPrice_color)}><HighlightSpan id={symbolInfo.code + "_pctChangePrice"} value={symbolInfo.pctChangePrice + (symbolInfo.pctChangePrice && symbolInfo.pctChangePrice !== '' ? '' : '')} fireEvent={_fireEvent} /></div> */}
                    <div className={clsx("prc-col2 text-right mw-65 bg-smoke", symbolInfo.matchPrice_color)}><HighlightSpan id={symbolInfo.code + "_matchQtty"} value={formatQtty(symbolInfo.matchQtty)} fireEvent={_fireEvent} /></div>

                    {priceBoardColumnConfig.showTotalTradedQtty && (
                        <>
                            {showTotalValue ? (
                                <div className={clsx("prc-col4 mw-85 text-right bg-smoke", (!configShowHideColumn.includes("colTotalBuy") ? 'hidden' : ''))}><HighlightSpan id={symbolInfo.code + "_totalTradedValueNM"} value={formatNumberToM(symbolInfo.totalTradedValueNM)} fireEvent={_fireEvent} /></div>
                            ) : (
                                <div className={clsx("prc-col4 mw-85 text-right bg-smoke", (!configShowHideColumn.includes("colTotalBuy") ? 'hidden' : ''))}><HighlightSpan id={symbolInfo.code + "_totalTradedQttyNM"} value={formatQtty(symbolInfo.totalTradedQttyNM)} fireEvent={_fireEvent} /></div>
                            )}
                        </>
                    )}
                    <div className={clsx("prc-col2 text-right bdl-white", symbolInfo.offerPrice1_color)}><HighlightSpan id={symbolInfo.code + "_offerPrice1"} value={symbolInfo.offerPrice1} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPrice1_color)}><HighlightSpan id={symbolInfo.code + "_offerQtty1"} value={formatQtty(symbolInfo.offerQtty1)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.offerPrice2_color)}><HighlightSpan id={symbolInfo.code + "_offerPrice2"} value={symbolInfo.offerPrice2} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPrice2_color)}><HighlightSpan id={symbolInfo.code + "_offerQtty2"} value={formatQtty(symbolInfo.offerQtty2)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right", symbolInfo.offerPrice3_color)}><HighlightSpan id={symbolInfo.code + "_offerPrice3"} value={symbolInfo.offerPrice3} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPrice3_color)}><HighlightSpan id={symbolInfo.code + "_offerQtty3"} value={formatQtty(symbolInfo.offerQtty3)} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right mw-65", (!configShowHideColumn.includes("colSellVol4") ? 'hidden' : ''), symbolInfo.offerPrice4_color)}><HighlightSpan id={symbolInfo.code + "_offerQtty4"} value={formatQtty(symbolInfo.offerQtty4)} fireEvent={_fireEvent} /></div>

                    <div className={clsx("prc-col2 text-right bg-smoke bdl-white", symbolInfo.avgPrice_color)}><HighlightSpan id={symbolInfo.code + "_avgPrice"} value={symbolInfo.avgPrice} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.highestPrice_color)}><HighlightSpan id={symbolInfo.code + "_highestPrice"} value={symbolInfo.highestPrice} fireEvent={_fireEvent} /></div>
                    <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.lowestPrice_color)}><HighlightSpan id={symbolInfo.code + "_lowestPrice"} value={symbolInfo.lowestPrice} fireEvent={_fireEvent} /></div>

                    {priceBoardColumnConfig.showBuyForeignQtty && (
                        <div className={clsx("prc-col2 text-right mw-70", (!configShowHideColumn.includes("colNNbuy") ? 'hidden' : ''))}><HighlightSpan id={symbolInfo.code + "_buyForeignQtty"} value={formatQtty(symbolInfo.buyForeignQtty)} fireEvent={_fireEvent} /></div>
                    )}
                    {priceBoardColumnConfig.showSellForeignQtty && (
                        <div className={clsx("prc-col2 text-right mw-70", (!configShowHideColumn.includes("colNNsell") ? 'hidden' : ''))}><HighlightSpan id={symbolInfo.code + "_sellForeignQtty"} value={formatQtty(symbolInfo.sellForeignQtty)} fireEvent={_fireEvent} /></div>
                    )}
                    {priceBoardColumnConfig.showRemainForeignQtty && (
                        <div className={clsx("prc-col4 text-right mw-90", (!configShowHideColumn.includes("colRoom") ? 'hidden' : ''))}><HighlightSpan id={symbolInfo.code + "_remainForeignQtty"} value={formatQtty(symbolInfo.remainForeignQtty)} fireEvent={_fireEvent} /></div>
                    )}
                </>
            )}
        </div>
    )
}));